/** The settings sections' ids and nothing else, so the url parser need not load their icons. */

/** In nav order. The first is the one the screen opens on. */
export const SECTION_IDS = [
  "stores",
  "delivery",
  "orders",
  "extension",
  "phone",
  "knows",
  "memory",
] as const;

export type SectionId = (typeof SECTION_IDS)[number];

/** Leaving `?section=` off the url spells this one. */
export const DEFAULT_SECTION: SectionId = SECTION_IDS[0];

/** Whether a `?section=` from the address bar names a section this screen actually has. */
export function isSectionId(value: unknown): value is SectionId {
  return typeof value === "string" && (SECTION_IDS as readonly string[]).includes(value);
}
